import styled from "styled-components";

const QuestionsContainer = styled.div``;

export {
  QuestionsContainer
}